import Button from '@mui/material/Button'

type Props = {
  children: React.ReactNode
  disabled?: boolean
  fullWidth?: boolean
  href?: string
  loading?: boolean
  size?: 'small' | 'medium' | 'large'
  onClick?: () => void
}

const UnderlineButton: React.FC<Props> = (props) => {
  const { children, disabled, loading, fullWidth, ...rest } = props

  return (
    <Button
      disabled={disabled || loading}
      fullWidth={fullWidth}
      sx={{
        '&::after': {
          backgroundColor: 'currentColor',
          bottom: '6px',
          content: '""',
          height: '1px',
          left: '4px',
          position: 'absolute',
          right: '-6px',
        },
        '&::before': {
          backgroundColor: 'currentColor',
          bottom: '6px',
          content: '""',
          height: '1px',
          position: 'absolute',
          right: '-6px',
          transform: 'rotate(45deg)',
          transformOrigin: 'right bottom',
          width: '12px',
        },
        position: 'relative',
        width: fullWidth ? '100%' : 'fit-content',
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default UnderlineButton
